"use client";

import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "../../../components/shared/data-table/data-table-column-header";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";

interface User {
  id: number;
  email: string;
  role: string;
  profile?: {
    name?: string;
    surname?: string;
  };
}

export const columns = (
  onEdit: (data: { id: number }) => void
): ColumnDef<User>[] => [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    enableSorting: true,
    enableHiding: false,
  },
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
  },
  {
    accessorKey: "role",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Role" />
    ),
  },
  {
    id: "actions",
    cell: ({ row }) => (
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onEdit({ id: row.original.id })}
      >
        <Edit className="h-4 w-4" />
      </Button>
    ),
  },
];
